module.exports = __webpack_public_path__ + "static/media/sad_face.ad45106f.svg";